import * as React from 'react';
import type { SVGProps } from 'react';

const SvgFacebook = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={43} height={43} {...props}>
    <g fill="none" fillRule="evenodd">
      <rect width={43} height={43} fill="#4460A0" rx={3} />
      <path
        fill="#FFF"
        d="M22 12c-5.523 0-10 4.477-10 10 0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V22h2.54v-2.203c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V22h2.773l-.443 2.89h-2.33v6.988C28.343 31.128 32 26.991 32 22c0-5.523-4.477-10-10-10z"
      />
    </g>
  </svg>
);
export default SvgFacebook;
